"use client"

import type { ReactNode } from "react"

import { Field, Checkbox as HUICheckbox, Label } from "@headlessui/react"

import { CheckIcon } from "@/components/ui/icons"
import { tv } from "@/lib/utils/tv"

const checkboxLabel = tv({ base: "font-text text-body text-fg inline-flex cursor-pointer items-center gap-250 has-disabled:cursor-not-allowed has-disabled:opacity-50" })

interface CheckboxProps {
  checked?: boolean
  indeterminate?: boolean
  onChange?: (checked: boolean) => void
  label?: ReactNode
  disabled?: boolean
  className?: string
}

export const Checkbox = ({ checked, indeterminate, onChange, label, disabled, className }: CheckboxProps) => (
  // Not a `<label>`: Headless UI renders the control as a span with role="checkbox",
  // which is not labelable, so a wrapping label forwards nothing and only the box
  // itself is clickable.
  <Field className={checkboxLabel({ className })}>
    <HUICheckbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      disabled={disabled}
      className="rounded-4x border-field border-line bg-surface data-checked:border-brand data-checked:bg-brand data-checked:text-fg-inverted data-indeterminate:border-brand data-indeterminate:bg-brand focus-visible:ring-brand flex size-5.5 shrink-0 items-center justify-center text-transparent transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
    >
      {indeterminate ? <span className="bg-fg-inverted h-0.5 w-2.5 rounded-full" /> : <CheckIcon size={14} />}
    </HUICheckbox>
    {label && <Label className="min-w-0 flex-1 cursor-pointer">{label}</Label>}
  </Field>
)
